import type { FaireProductEntity } from "../../entity_types/product";

export const p_cuwud2tvkp: FaireProductEntity = {
  token: "p_cuwud2tvkp",
  type: "product",
  name: "COEXIST MULTI PATCHES MA-1 JACKET",
  brandToken: "b_kmqjsus8ac",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7f106553dbeebdf4846657eb517823f8416396bcf7a876887338745594346bb6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9885d1903bc31462d3180d2f3ac3d6d5754436bcf12e0292be2c8bdd33ff36b8.jpeg",
    "https://cdn.faire.com/fastly/ce863b1ef2092d7bc5ab356b864f3568aaab1ac77bcb48a7f07c0c3ad946cd2a.jpeg",
    "https://cdn.faire.com/fastly/613d2d383c35c8999b3fe2af283c9fd0c534ad331ceed3cfb3b62ed45ef90b7a.jpeg",
    "https://cdn.faire.com/fastly/3d712f83dd0ffe67d934550ff66b6df5d44cc326730b5e044fead9b528a8785b.jpeg",
    "https://cdn.faire.com/fastly/f76426ad5497317dee4466eefe36b6314dbdf1cbc7899f0ff04e302c6f851ffb.jpeg",
    "https://cdn.faire.com/fastly/c25d7f02b0d22cc41d1a6a24e7849047853d0171ef358d412133238d8e81244e.jpeg",
    "https://cdn.faire.com/fastly/347c38d9fc7804cb53263ff75e0fc8a03f839d48e5ac04ae006e57bc7d5234d0.jpeg",
    "https://cdn.faire.com/fastly/ef8f53d4936eb31bac21a827765ed8e06c8b35b202519be21188b486434152d4.jpeg",
    "https://cdn.faire.com/fastly/3cb80669b81777b85068e6bcd86495b3c443bc5460f3537ca726688a4cb28bd3.jpeg",
    "https://cdn.faire.com/fastly/7a9d856e8e8ea1ff75e63bd44b64323edbf5e0903c7c230de8e2071c98e637db.jpeg",
    "https://cdn.faire.com/fastly/45df248cdd9363141e7b7e2e4f9f57f6ab8910dcc6a2ee19da30868322a25110.jpeg",
    "https://cdn.faire.com/fastly/37433e157cc0e63a18cfd968593479f4d7e956a7c33425019e50a1a2c4a296cd.jpeg",
    "https://cdn.faire.com/fastly/fc1b918f60571d92621e9528e837f520fe955fe34267e1267b1c134f5f03ce71.jpeg",
    "https://cdn.faire.com/fastly/6125842aade6cea7611092b5258a6c7c25aa631917429c151d896bc00df4804f.jpeg",
    "https://cdn.faire.com/fastly/8f96725b5b27a858ae5b5e1c831c70e5883865b60e046c0c306a5e5a4ecbdeb7.jpeg",
  ],
  priceDollars: 332.57,
  description:
    'A comfy oversized MA-1 bomber jacket with utility detail. Featuring a rib-knit banding at the cuffs hem for a comfortable fit with warm quilting inside lining and center front zipper closure.\n\nSIZE S /  CHEST(HALF MEASURE) 22 1/4" / FRONT BODY LENGTH 19 3/4" / SLEEVE 23 1/4"\n',
  tags: [],
  msrpDollars: 665.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:23.070Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
